import UFunction from "./UFunction.mts";

type Codec<Decoded, Encoded> = {
  encode: (value: Decoded) => Encoded;
  decode: (value: Encoded) => Decoded;
};

namespace Codec {
  export const Identity = UFunction.memo(
    <T,>(): Codec<T, T> => ({
      encode: UFunction.identity,
      decode: UFunction.identity,
    })
  );
}

export default Codec;
